import { useEffect, useRef, useState } from 'react';
import Input from '../atoms/Input';
import { useDispatch } from 'react-redux';
import {
  setPage,
  setSearch,
  usePublicState,
} from '../../store/slices/publicSlice';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import SearchIcon from '../../assets/icons/SearchIcon';

export interface SearchProps {
  searchName?: string;
  inputWidth?: string;
  placeholder?: string;
  className?: string;
  'data-testid'?: string;
}

export default function Search({
  searchName = 'search',
  inputWidth = 'w-96',
  placeholder,
  className,
  'data-testid': dataTestId,
}: SearchProps) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { search } = usePublicState();
  const [value, setValue] = useState(search?.[searchName] || '');
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const handler = setTimeout(() => {
      dispatch(
        setSearch({
          key: searchName,
          value,
        })
      );
      dispatch(setPage(0));
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [value, searchName, dispatch]);

  return (
    <Input
      name="search"
      id="search"
      data-testid={dataTestId || `${searchName}-search-input`}
      placeholder={placeholder || t('home.searchHere')}
      value={value}
      prefix={<SearchIcon />}
      onChange={(e) => setValue(e.target.value)}
      className={classNames(
        inputWidth,
        !inputWidth?.includes('rounded') && !className?.includes('rounded') && '!rounded-md',
        className
      )}
      onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
    />
  );
}
